import { apiClient } from './client';
import type { LoginRequest, LoginResponse, UserInfo, TenantMembership, ProfileUpdate, ChangePasswordRequest, ForgotPasswordRequest, SetPasswordRequest, PasswordPolicy } from '@/types';

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const { data: response } = await apiClient.post<LoginResponse>('/api/v1/auth/login', data);
    return response;
  },

  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/api/v1/auth/logout');
    } catch {
      // Ignorar errores de logout en cliente
    }
  },

  getProfile: async (): Promise<UserInfo> => {
    const { data } = await apiClient.get<UserInfo>('/api/v1/auth/me');
    return data;
  },

  memberships: async (): Promise<TenantMembership[]> => {
    const { data } = await apiClient.get<TenantMembership[]>('/api/v1/auth/memberships');
    return data;
  },

  switchContext: async (tenantId: string): Promise<UserInfo> => {
    const { data } = await apiClient.post<UserInfo>('/api/v1/auth/context/switch', { tenant_id: tenantId });
    return data;
  },

  updateProfile: async (data: ProfileUpdate): Promise<UserInfo> => {
    const { data: response } = await apiClient.patch<UserInfo>('/api/v1/auth/me', data);
    return response;
  },

  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    await apiClient.post('/api/v1/auth/change-password', data);
  },

  forgotPassword: async (data: ForgotPasswordRequest): Promise<void> => {
    await apiClient.post('/api/v1/auth/forgot-password', data);
  },

  /**
   * Consumo del enlace de establecimiento de un solo uso. Cubre el alta y el
   * restablecimiento: es el mismo mecanismo, no dos endpoints.
   */
  setPassword: async (data: SetPasswordRequest): Promise<void> => {
    await apiClient.post('/api/v1/auth/set-password', data);
  },

  /** Política vigente, para que el checklist no duplique las reglas. */
  passwordPolicy: async (): Promise<PasswordPolicy> => {
    const { data } = await apiClient.get<PasswordPolicy>('/api/v1/auth/password-policy');
    return data;
  },
};
